import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=47291527&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47291527",
  null
  
)

export default component.exports